import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import VisualCards from './components/VisualCards';
import CategoryGrid from './components/CategoryGrid';
import BlogSection from './components/BlogSection';
import ComparisonSection from './components/ComparisonSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://litbuyspreadsheets.store';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Litbuy Spreadsheets',
  url: siteUrl,
  description: 'Your complete resource center for Litbuy Spreadsheet guides, templates, safety resources, and comprehensive comparisons. Helping users make informed decisions about spreadsheet productivity tools.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Litbuy Spreadsheets',
  url: siteUrl,
  description: 'Educational resource providing Litbuy Spreadsheet guides, templates, and safety information.',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: 'What is Litbuy Spreadsheet?', acceptedAnswer: { '@type': 'Answer', text: 'Litbuy Spreadsheet is a modern spreadsheet solution designed to help users organize, track, and manage data efficiently. It combines automation features with an intuitive interface, making it suitable for both beginners and experienced users who need reliable spreadsheet tools for their daily workflows.' } },
    { '@type': 'Question', name: 'Is Litbuy Spreadsheet safe to use?', acceptedAnswer: { '@type': 'Answer', text: 'Yes, Litbuy Spreadsheet is designed with security in mind. Users should follow standard security best practices including using strong passwords, enabling two-factor authentication when available, and only accessing the platform through trusted connections.' } },
    { '@type': 'Question', name: 'How do beginners get started with Litbuy Spreadsheet?', acceptedAnswer: { '@type': 'Answer', text: 'Beginners can start by exploring pre-built templates, following step-by-step guides available on our resource center, and practicing with sample datasets. We recommend starting with basic operations like data entry and simple formulas before moving on to more advanced features.' } },
    { '@type': 'Question', name: 'Can Litbuy Spreadsheet improve my productivity?', acceptedAnswer: { '@type': 'Answer', text: 'Absolutely. Many users report significant productivity gains after adopting Litbuy Spreadsheet. Features like automated calculations, template-based workflows, and real-time data tracking help reduce manual work and minimize errors.' } },
    { '@type': 'Question', name: 'Are Litbuy Spreadsheet templates free?', acceptedAnswer: { '@type': 'Answer', text: 'Some templates and resources are freely available, while others may require registration or purchase through the main Litbuy Spreadsheet platform. We recommend visiting the official website to explore the full range of template options.' } },
    { '@type': 'Question', name: 'How does Litbuy Spreadsheet compare to traditional spreadsheets?', acceptedAnswer: { '@type': 'Answer', text: 'Litbuy Spreadsheet offers several advantages over traditional spreadsheets, including built-in automation, streamlined data tracking, automatic updates, and a more user-friendly interface.' } },
    { '@type': 'Question', name: 'Do I need technical skills to use Litbuy Spreadsheet?', acceptedAnswer: { '@type': 'Answer', text: 'No advanced technical skills are required. Litbuy Spreadsheet is designed with accessibility in mind, featuring an intuitive interface and helpful onboarding resources.' } },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <VisualCards />
        <CategoryGrid />
        <BlogSection />
        <ComparisonSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}